import { render } from "./PoliticPage.vue?vue&type=template&id=e9ca9774"
import script from "./PoliticPage.vue?vue&type=script&lang=js"
export * from "./PoliticPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__